import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const FaqSection = () => {
  const faqs = [{
    q: '¿Cómo recibo el Mega Pack después de comprar?',
    a: 'Inmediatamente después de confirmar el pago recibís un email con los links de descarga de todos los módulos y bonos en PDF. El acceso es inmediato, las 24 horas, los 7 días. Si no llega el email revisá spam o escribinos.'
  }, {
    q: '¿Para qué carrera sirve?',
    a: 'Para cualquier carrera con materias de programación: Ingeniería en Sistemas, Licenciatura en Informática, Ingeniería en Computación, Analista de Sistemas. Funciona para UTN, UBA, UNLP, UADE, UNC, UNR y cualquier universidad argentina.'
  }, {
    q: '¿Necesito saber programar para empezar?',
    a: 'No. El Mega Pack está diseñado desde cero y escala progresivamente. Si ya sabés lo básico, vas a encontrar contenido de nivel intermedio y avanzado desde el Módulo 1.'
  }, {
    q: '¿Los 3 bonos están incluidos siempre?',
    a: 'Sí. Los 3 bonos están incluidos en todas las compras sin costo adicional. No es una oferta limitada. Es parte del sistema completo.'
  }, {
    q: '¿Funciona si ya estoy en años avanzados?',
    a: 'Absolutamente. El Módulo 6 está pensado específicamente para estudiantes que están buscando su primer trabajo. Los Módulos 1 al 5 sirven para repasar y profundizar conceptos en cualquier año.'
  }, {
    q: '¿Puedo usarlo con IA gratuita?',
    a: 'Sí. Todos los prompts del Bono 3 están probados con ChatGPT-4o en el plan gratuito. No necesitás pagar ninguna suscripción de IA para aprovechar el 100% del pack.'
  }, {
    q: '¿Es compatible con cualquier lenguaje?',
    a: 'El contenido principal usa Python y Java, los más pedidos en universidades argentinas. Los conceptos de Algoritmos, POO y Base de Datos son universales y aplican a cualquier lenguaje.'
  }, {
    q: '¿Necesita internet para usarlo?',
    a: 'Una vez descargados los PDFs, podés usarlos sin internet. Solo necesitás conexión para los ejercicios que involucran IA (Módulo 4 y Bono 3).'
  }, {
    q: '¿Es diferente a un apunte de facultad?',
    a: 'Completamente distinto. No es un resumen del apunte. Es un sistema de aprendizaje activo con ejercicios resueltos, código funcional, casos reales y checklists de dominio. Pensado para aprobar y conseguir trabajo, no solo para leer.'
  }, {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Tarjeta de crédito y débito, Mercado Pago, Ualá y transferencia bancaria. Pago 100% seguro. En cuotas con tarjetas de crédito según tu banco.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, escribinos a soporte y te devolvemos el 100% sin preguntas. Sin formularios. Sin drama.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-megapack-section py-10 md:py-16 px-4 md:px-6" data-id="element-67">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-68">
        <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-69">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2 md:space-y-4" data-id="element-70">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-megapack-cyan bg-megapack-card' : 'border-megapack-cyan/20 bg-megapack-bg'}`} data-id="element-71">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-4 md:px-6 py-3 md:py-5 text-left flex justify-between items-center gap-3" data-id="element-72">
                  <span className="font-bold text-[14px] sm:text-base" data-id="element-73">
                    {faq.q}
                  </span>
                  <span className={`text-megapack-cyan text-2xl transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-45' : ''}`} data-id="element-74">
                    +
                  </span>
                </button>
                <AnimatePresence data-id="element-75">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-76">
                      <div className="px-4 md:px-6 pb-4 md:pb-6 pt-2 text-megapack-gray text-[14px] sm:text-base leading-relaxed border-t border-white/5" data-id="element-77">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};